export default __webpack_public_path__ + "static/media/social.75071e34.jpg";